import { observer } from "mobx-react";
import * as React from "react";
import { Button, FormGroup, InputGroup, Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { AppStore } from "../../stores/AppStore";
import { api } from "../../api";
import { LoginStore } from "../../stores/login/LoginStore";
import { isValidPassword } from "../../utils";

@observer
export class ChangePassword extends React.Component<{}, {}> {

  obs = observable({
    chave: window.location.pathname.split("/")[2] as string,
    password: "" as string,
    password_confirm: "" as string,
    formErrors: [] as any,
    loading: false as boolean
  })

  constructor(props: any) {
    super(props);
  }

  handleValidPassword() {
    let err: any = {}

    if (this.obs.password == "") {
      err.password = "Senha obrigatória!"
    } else {
      if (!isValidPassword(this.obs.password)) {
        err.password = "Senha inválida!"
      } else {
        if (this.obs.password_confirm != "") {
          if (this.obs.password_confirm != this.obs.password) {
            err.confirma_password = "Senhas divergentes!"
          }
        }
      }
    }

    if (this.obs.password_confirm == "") {
      err.password_confirm = "Senha obrigatória!"
    }

    this.obs.formErrors = err
    return Object.keys(err).length < 1;
  }

  async handleSavePassword() {
    this.obs.loading = true
    if (this.handleValidPassword()) {
      let data = { "chave": this.obs.chave, "senha": this.obs.password, "senha_confirm": this.obs.password_confirm }
      let resp = await LoginStore.handleSalvarSenha(data)

      if (resp.ok) {
        this.obs.loading = false
        window.location.href = "/login";
      } else {
        this.obs.formErrors.error_back = "Erro ao alterar senha, tente novamente mais tarde!"
      }
    }
    this.obs.loading = false
  }

  isValidLength() {
    let length = /^.{6,}$/

    if (length.test(this.obs.password)) {
      return <img src="/images/checked.png" width="12px" />
    } else {
      return <img src="/images/cancel.svg" width="12px" />
    }
  }

  isValidMaisculo() {
    let main = /[A-Z]/

    if (main.test(this.obs.password)) {
      return <img src="/images/checked.png" width="12px" />
    } else {
      return <img src="/images/cancel.svg" width="12px" />
    }
  }

  isValidMinusculo() {
    let min = /[a-z]/

    if (min.test(this.obs.password)) {
      return <img src="/images/checked.png" width="12px" />
    } else {
      return <img src="/images/cancel.svg" width="12px" />
    }
  }

  isValidNumber() {
    let number = /\d/

    if (number.test(this.obs.password)) {
      return <img src="/images/checked.png" width="12px" />
    } else {
      return <img src="/images/cancel.svg" width="12px" />
    }
  }

  isValidCaracter() {
    let caracter = /[!@#$%^&*()\-_+=\[{\]};:<>|./?]/

    if (caracter.test(this.obs.password)) {
      return <img src="/images/checked.png" width="12px" />
    } else {
      return <img src="/images/cancel.svg" width="12px" />
    }
  }

  render() {

    return (
      <>
        <div className="container-fluid container-login">
          <MDBRow>
            <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
              <div className="login-img">
                <img src="/images/logo-novo.png" className="img-responsive" />
              </div>

              <h3 className="title-login" style={{ textAlign: "center" }}>Insira uma nova senha
                <span className="non-valid">{this.obs.formErrors.error_back}</span>
              </h3>

              <FormGroup
                className="form-group"
                label="Senha">
                <Tooltip position="right" content={
                  <div>
                    <p><b>Obrigatório:</b></p>

                    <p>6 Caracteres {this.isValidLength()}</p>
                    <p>1 Letra maiúscula {this.isValidMaisculo()} </p>
                    <p>1 Letra minúscula {this.isValidMinusculo()} </p>
                    <p>1 Número {this.isValidNumber()} </p>
                    <p>1 Caractere especial {this.isValidCaracter()} </p>

                  </div>
                }>
                  <InputGroup type="password" onChange={(e: any) => this.obs.password = e.target.value} placeholder="***********" className="input-senha" />
                </Tooltip>
                <span className="non-valid">{this.obs.formErrors.password}</span>
                <span className="non-valid">{this.obs.formErrors.confirma_password}</span>
              </FormGroup>

              <FormGroup
                className="form-group"
                label="Confirmar Senha">
                <InputGroup type="password" onChange={(e: any) => this.obs.password_confirm = e.target.value} placeholder="***********" className="input-senha" />
                <span className="non-valid">{this.obs.formErrors.password_confirm}</span>
                <span className="non-valid">{this.obs.formErrors.confirma_password}</span>
              </FormGroup>

              <div className="actions-form" style={{ marginBottom: 20 }}>
                {!this.obs.loading
                  ? <Button className="btn btn-login" onClick={() => this.handleSavePassword()}>Salvar</Button>
                  : <Button className="btn btn-login">
                    <i className="fa fa-spinner fa-spin"></i>
                    Carregando
                  </Button>
                }
              </div>

              <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                <div>© 2023 . Todos os Direitos Reservados.</div>
              </div>

            </MDBCol>

            <MDBCol md="6" className="fundo-login">
              <div className="fundo-bg"></div>
            </MDBCol>

          </MDBRow>

        </div>
      </>
    );
  }
}

export default ChangePassword;
